export const COMPANY_NAME = "Universal";
export const COMPANY_TAGLINE = "Surgical Assistants";
export const COMPANY_PHONE_TEXT =["800-936-0074", "832-655-4141"];// ["832-655-4141", "800-936-0074/(832)-655-4141"];
export const COMPANY_Sec_PHONE_TEXT = "800-936-0074";//"(800)-936-0074";
export const COMPANY_PHONE_URL = "tel:+8326554141";
export const COMPANY_EMAIL = "contact@universalsa.com";
export const SCHEDULE_A_PROCEDURE = "Schedule a Procedure";
export const PATIENT_RESOURCES_PAYMENTS = "Patient Resources - Payments";
export const PA_RESIDENCY_TRAINING_PROGRAM = "PA Residency Training Program";
export const PHYSICIAN_DIRECTORY = "Physicians Directory";
//export const COMPANY_LOCATION = "1 SUGAR CREEK CENTER BLVD SUITE 618 SUGAR LAND TX 77478";
export const COMPANY_LOCATION = "1 Sugar Creek Center Blvd Suite 618 Sugar Land TX 77478";//"1 SUGAR CREEK CENTER BLVD SUITE 618 SUGAR LAND TX 77478";
export const COMPANY_FACEBOOK = "https://www.facebook.com/UniversalSurgicalPartners/";
export const COMPANY_TWITTER = "https://twitter.com/uspartnersinc";
export const COMPANY_INSTAGRAM = "https://www.instagram.com/usassistants/#";
export const COMPANY_YOUTUBE = "https://www.youtube.com/channel/UCNzMTE5RO-wVoBbr1R80EmA";
export const COMPANY_LINKEDIN = "https://www.linkedin.com/company/universal-surgical-partners";
export const DATA_PER_PAGE = 6;
export const RECAPTCHA_SITE_KEY = "6LfmifYoAAAAAEu4qsgEeujnG7JsUeDk-6gyx6gC";
export const RECAPTCHA_SECRET_KEY = "6LfmifYoAAAAAB4In_LZ1lbG1x64foiS2FIRy6Py";
export const DONATE_URL = "https://www.paypal.com/donate/?hosted_button_id=P3FYT55GB86C4";
export const PLAY_STORE_URL = "https://play.google.com";
export const APP_STORE_URL = "https://app.apple.com";

// constants/filterOptions.js

export const FILTER_OPTIONS = [
  {
    key: "job__category_spec",
    label: "All Job Category",
    item: "category",
    options: ["Medical"],
  },
  {
    key: "job__type_spec",
    label: "All Job Type",
    item: "type",
    options: ["Full Time"],
  },
  {
    key: "job__location_spec",
    label: "All Job Location",
    item: "location",
    options: ["United States"],
  },
];

export const HEADER_MENUS = [
  {
    title: "About Us",
    slug: "/about",
  },
  {
    title: "Services",
    slug: "/services",
  },
  {
    title: "Specialities",
    slug: "#",
    sub: [
      {
        title: "CARDIOTHORACIC SURGERY",
        slug: "/cardiothoracic-surgery",
      },
      { title: "ORTHOPEDIC SURGERY", slug: "/orthopedic-surgery" },
      { title: "ROBOTIC SURGERY", slug: "/robotic-surgery" },
      {
        title: "NEUROSPINAL SURGERY",
        slug: "/neurospinal-surgery",
      },
      { title: "GENERAL SURGERY", slug: "/general-surgery1" },
      { title: "OB/GYN SURGERY", slug: "/ob-surgery" },
    ],
  },
  {
    title: "Providers",
    slug: "#",
    sub: [
      { title: "PHYSICIAN ASSISTANTS", slug: "/physician-assistants" },
      { title: "SURGICAL ASSISTANTS", slug: "/surgical-assistants" },
      {
        title: "Travel Surgical Assistants",
        slug: "/travel-surgical-assistants",
      },
      {
        title: "INTERNATIONAL PHYSICIANS",
        slug: "/international-physicians",
      },
      // { title: "PHYSICIAN DIRECTORY", slug: "/physician-directory" },
      // { title: "GENERAL SURGERY", slug: "/general-surgery" },
    ],
  },
  {
    title: "PHYSICIAN DIRECTORY",

    slug: "/physician-directory",
    sub: [
      { title: "GENERAL SURGERY", slug: "/general-surgery?specialty=General Surgery" },
      { title: "CARDIOTHORACIC SURGERY", slug: "/general-surgery?specialty=Cardio-Thoracic" },
      { title: "NEUROSPINAL SURGERY", slug: "/general-surgery?specialty=Neuro-Spinal" },
      { title: "OB/GYN SURGERY", slug: "/general-surgery?specialty=Obs-Gyn" },
      { title: "ORTHOPEDIC SURGERY", slug: "/general-surgery?specialty=Orthopedic" },
      { title: "ROBOTIC SURGERY", slug: "/general-surgery?specialty=Robotic" },
    ],
  },
  {
    title: "Careers",

    slug: "/careers",
    // sub: [
    //   {
    //     title: "Travel Surgical Assistants",
    //     slug: "/travel-surgical-assistants",
    //   },
    // ],
  },
  // {
  //   title: "INTERNATIONAL PHYSICIANS",
  //   slug: "/international-physicians",
  // },
  {
    title: "Contact Us",
    slug: "/contact-us",
  },
];

// export const ALLOWED_FILE_TYPES = [
// 	"image/png",
// 	"image/jpeg",
// 	"image/jpg",
// 	"application/pdf",
// ];

/* =================================================== 
	API URL 
=================================================== */

// const API_MAPPING = {
//   DEV: {
//     url: "https://coremax-java-be.octopi-labs.com",
//   },
//   PROD: {
//     url: "https://java-be.coremaxcloud.com",
//   },
// };

// export const API_URL = API_MAPPING[process.env.MODE].url;
// export const VERSION = process.env.VERSION;
